import request from '@/utils/request'
import qs from 'qs'

export function getWatchModelList(data) {
    data = qs.stringify(data)
    return request({
        url: '/watchModel/getWatchModelList',
        method: 'post',
        data
    })
}

export function getDeviceList(data) {
    data = qs.stringify(data)
    return request({
        url: '/device/getDeviceList',
        method: 'post',
        data
    })
}

export function addDevice(data) {
    data = qs.stringify(data)
    return request({
        url: '/device/addDevice',
        method: 'post',
        data
    })
}

export function updateDevice(data) {
    data = qs.stringify(data)
    return request({
        url: '/device/updateDevice',
        method: 'post',
        data
    })
}

export function importDevice(data) {
    return request({
        url: '/device/importDevice',
        method: 'post',
        requestBody: 'body',
        loading: true,
        data: data
    })
}

export function deleteDevice(data) {
    return request({
        url: '/device/deleteDevice',
        method: 'post',
        requestBody: 'body',
        loading: true,
        data: data
    })
}

export function deleteWatchBind(data) {
    data = qs.stringify(data)
    return request({
        url: '/device/deleteWatchBind',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/device.js